import D1 from "../../components/ExcerciseTypes/Design/TypeIn";
import Circle_Write from '../../components/ExcerciseTypes/Circle_Write';
import UI from "../../components/ExcerciseTypes/Design/UserInterface";

const json = {
  1: { // Exercise num
    unit: 'Unit 9',
    id: 'SB3-U9-P63-E1',
    audio: 'img/FriendsPlus/Page63/Audio/audio-e1-p63.mp3',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page63/E1/1.jpg' },
        { url: 'img/FriendsPlus/Page63/E1/2.jpg', audioUrl: 'img/FriendsPlus/Page63/Audio/tieude-e1-p63.mp3' },
        { url: 'img/FriendsPlus/Page63/E1/3.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page63/E1/4.jpg', audioUrl: 'img/FriendsPlus/Page63/Audio/hinh1-e1-p63.mp3' },
        { url: 'img/FriendsPlus/Page63/E1/5.jpg', audioUrl: 'img/FriendsPlus/Page63/Audio/hinh2-e1-p63.mp3' },
        { url: 'img/FriendsPlus/Page63/E1/6.jpg', audioUrl: 'img/FriendsPlus/Page63/Audio/hinh3-e1-p63.mp3' },
        { url: 'img/FriendsPlus/Page63/E1/7.jpg', audioUrl: 'img/FriendsPlus/Page63/Audio/hinh4-e1-p63.mp3' },
      ],
    ],
  },
  2: { // Exercise num
    unit: 'Unit 9',
    id: 'SB3-U9-P63-E2',
    audio: 'img/FriendsPlus/Page63/Audio/audio-e2-p63.mp3',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page63/E2/1.jpg' },
        { url: 'img/FriendsPlus/Page63/E2/2.jpg', audioUrl: 'img/FriendsPlus/Page63/Audio/tieude-e2-p63.mp3' },
        { url: 'img/FriendsPlus/Page63/E2/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page63/E2/4.jpg' },
      ],
    ],
  },
  3: { // Exercise num
    // Exercise num
    unit: 'Unit 9',
    id: 'SB3-U9-P63-E3',
    audio: '',
    video: '',
    component: Circle_Write,
    exerciseKey: 'img/FriendsPlus/Page63/E3/Key/answerKey.png',
    titleQuestion: [{ num: '3', title: 'Read the chant again. Circle the sound o_e.', color: "#1F4199" }],
    question: {
      Write: {
        inputStyle: {},
        answers: [],
        initialValue: [],
      },
      Circle: {
        // initialWordStyle: { margin: '5px 0', border: 'solid 2px', borderColor: 'black', borderRadius: '50%', padding: '0 5px' },
        initialWordStyle: { margin: '5px 0', border: 'none', borderColor: 'transparent', borderRadius: '50%' },
        selectWordStyle: { border: 'solid 2px', borderColor: '#00a8ec', padding: '0 5px' },
        listWords: [
          'The fox is on a st|one.',//0
          'Hu|rry up, fox.',//1
          'I w|ant to go h|ome.',//2
          'My n|ose is c|old.',//3
          'H|ere is a b|one.',//4
          'Hu|rry up, fox.',//5
          'I w|ant to go h|ome.'//6
        ],
        answers: ['0-12', '2-12', '3-4', '4-10', '6-12'],
        initialValue: [],
      },
      Layout: `
        <div style='display: flex; flex-direction: row;position: relative;align-items: center;background-color: #fde9bc; padding: 20px;'>
          <div style='width: 50%; margin-left: 20px; color: #ec870e;text-align: center;'>
            <div>The fox has my r<span style="border: 2px solid rgb(0, 168, 236); border-radius: 50%; padding: 0px 5px;">ope.</span></div>
            <div><input id='0' type='Circle' /></div>
            <div><input id='1' type='Circle' /></div>
            <div><input id='2' type='Circle' /></div>
            <div><input id='3' type='Circle' /></div>
            <div><input id='4' type='Circle' /></div>
            <div><input id='5' type='Circle' /></div>
            <div><input id='6' type='Circle' /></div>
          </div>
          <div style='width: '50%'>
            <img src="img/FriendsPlus/Page63/E3/1.jpg" style="width: 100%">
          </div>
        </div>
      `,
    },
  },
  4: { // Exercise num
    unit: 'Unit 9',
    id: 'SB3-U9-P63-E4',
    audio: 'img/FriendsPlus/Page63/Audio/audio-e4-p63.mp3',
    video: '',
    component: D1,
    exerciseKey: 'img/FriendsPlus/Page63/E4/Key/answerKey.png',
    isAllowSubmit: false,
    maxLength: 2,
    textAlign: 'center',
    padding: 0,
    question: [],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page63/E4/1.jpg' },
        { url: 'img/FriendsPlus/Page63/E4/2.jpg', audioUrl: 'img/FriendsPlus/Page63/Audio/tieude-e4-p63.mp3' },
        { url: 'img/FriendsPlus/Page63/E4/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page63/E4/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page63/E4/5.jpg' },
        { url: 'img/FriendsPlus/Page63/E4/6.jpg', input: true, answer: "st" },
        { url: 'img/FriendsPlus/Page63/E4/7.jpg' },
        { url: 'img/FriendsPlus/Page63/E4/8.jpg', input: true, answer: "n" },
        { url: 'img/FriendsPlus/Page63/E4/9.jpg' },
        { url: 'img/FriendsPlus/Page63/E4/10.jpg', input: true, answer: "h" },
        { url: 'img/FriendsPlus/Page63/E4/11.jpg' },
        { url: 'img/FriendsPlus/Page63/E4/12.jpg', input: true, answer: "m" },
        { url: 'img/FriendsPlus/Page63/E4/13.jpg' },
        { url: 'img/FriendsPlus/Page63/E4/14.jpg', input: true, answer: "b" },
        { url: 'img/FriendsPlus/Page63/E4/15.jpg' },
        { url: 'img/FriendsPlus/Page63/E4/16.jpg', input: true, answer: "n" },
        { url: 'img/FriendsPlus/Page63/E4/17.jpg' },
      ],
    ]
  },
  5: { // Exercise num
    unit: 'Unit 9',
    id: 'SB3-U9-P63-E5',
    audio: '',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: 'img/FriendsPlus/Page63/E5/1.jpg' }]],
  },
}

export default json;